module.exports = __webpack_public_path__ + "static/img/2.d9bea6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/plans/snip3down/2.png
// module id = m+CD
// module chunks = 35